import React, { useEffect, useState } from "react";
import DataOverview from "../components/data/DataOverview";
import { useLocation, useMatch, useParams } from "react-router-dom";
import Loader from "../components/layouts/Loader";

const tableName = "content";
const textName = 'Content';
const editPathName = "/content/:id";
const tableColumns = [
  {
    displayName: "URL",
    dataField: "slug",
    sort: true,
  },
  {
    displayName: "Title",
    dataField: "title",
    sort: true,
  },
  {
    displayName: "Tools",
    dataField: "tools",
    sort: false,
  },
];
const fieldData = [
  {
    displayName: "URL",
    placeholder: "URL",
    fieldName: "slug",
    fieldType: "text",
    colSize: 2,
    required: true,
    requiredMessage: "Page URL",
  },
  {
    displayName: "Title",
    fieldName: "title",
    fieldType: "text",
    colSize: 2,
    required: true,
    requiredMessage: "Page Title",
  },
  {
    displayName: "Content",
    fieldName: "content",
    fieldType: "content",
    colSize: 1,
    required: false,
  },
];
const fieldDataDefault = {
  pageUrl: "",
  pageTitle: "",
  pageHTML: "",
};

const Content = () => {
  const { id } = useParams();
  const location = useLocation();
  const match = useMatch(editPathName);
  const [loading, setLoading] = useState(true);
  let parentRoute = location.pathname;
  useEffect(() => {
    setLoading(false);
  }, []);

  if (match) {
    parentRoute = match.pattern.path.replace("/:id", "");
  }

  if (loading) return <Loader />;
  return (
    <DataOverview
      id={id ?? ""}
      tableName={tableName}
      pageMode={id ? "edit" : "list"}
      route={location.pathname}
      parentRoute={parentRoute}
      pageTitle={textName}
      listTitle={textName}
      listSubTitle={""}
      addTitle={"Add "}
      addSubTitle={""}
      editTitle={`Edit ${textName}`}
      editSubTitle={""}
      tableColumns={tableColumns}
      fieldData={fieldData}
      fieldDataDefault={fieldDataDefault}
    />
  );
};

export default Content;
